export default __webpack_public_path__ + "static/media/empty_streak.365ae46b.svg";